import React, { useContext } from 'react';
import { ModalDialogSizes } from '../ModalDialogTypes';

const ModalDialogSizeContext = React.createContext<undefined | ModalDialogSizes>(undefined);

export const useModalDialogSizeContext = () => useContext(ModalDialogSizeContext);

export default ModalDialogSizeContext;
